import { useEffect, useState } from "react";
import { BellRing, Download, X } from "lucide-react";
import { Capacitor } from "@capacitor/core";
import { track } from "@/lib/analytics";

/** Link do APK (bucket publico "app" do Supabase Storage). Para atualizar, suba o APK novo com o mesmo nome. */
export const APK_URL = "https://zmtqkgtavnzkxxcebzxm.supabase.co/storage/v1/object/public/app/agroaluga.apk";

const KEY = "agro:apk-prompt-dismissed";
const AGAIN_AFTER_DAYS = 7;

function shouldShow() {
  try { if (Capacitor.isNativePlatform()) return false; } catch { /* web */ }
  if (!/android/i.test(navigator.userAgent)) return false; // o APK so instala em Android
  try {
    const t = Number(localStorage.getItem(KEY)) || 0;
    return Date.now() - t > AGAIN_AFTER_DAYS * 86400000;
  } catch {
    return true;
  }
}

/** Aviso no chat (site no Android): baixe o app para receber as mensagens na hora */
export default function AppDownloadPrompt() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!shouldShow()) return;
    const t = setTimeout(() => { setOpen(true); track("apk_prompt_visto", { type: "funnel" }); }, 1500);
    return () => clearTimeout(t);
  }, []);

  function close(reason: "fechou" | "baixou") {
    try { localStorage.setItem(KEY, String(Date.now())); } catch { /* sem armazenamento */ }
    track(reason === "baixou" ? "apk_prompt_baixar" : "apk_prompt_fechar", { type: "click" });
    setOpen(false);
  }

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/40 p-3 sm:items-center" onClick={() => close("fechou")}>
      <div
        className="relative w-full max-w-sm overflow-hidden rounded-2xl border border-[#ebe7dc] bg-white p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-label="Baixe o app do AgroAluga"
      >
        <span className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#e0a021] to-[#2d7a4d]" />
        <button onClick={() => close("fechou")} className="absolute right-3 top-3 rounded-full p-1 text-[#8a9088] hover:bg-[#f7f5ef]" aria-label="Fechar">
          <X className="h-4 w-4" />
        </button>
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#eaf2ec] text-[#2d7a4d]">
            <BellRing className="h-5 w-5" />
          </span>
          <div>
            <p className="text-[15px] font-bold leading-tight text-[#1a4a2e]">Não perca nenhuma mensagem</p>
            <p className="text-xs text-[#8a9088]">App do AgroAluga para Android</p>
          </div>
        </div>
        <p className="mt-3 text-sm leading-relaxed text-[#1f2621]">
          Com o app instalado, você recebe um aviso no celular assim que alguém responder, sem precisar abrir o site.
        </p>
        <a
          href={APK_URL}
          onClick={() => close("baixou")}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-[#2d7a4d] px-4 py-3 text-sm font-semibold text-white transition hover:brightness-95"
        >
          <Download className="h-4 w-4" /> Baixar o app (APK)
        </a>
        <button onClick={() => close("fechou")} className="mt-2 w-full rounded-xl py-2 text-[13px] font-semibold text-[#8a9088] hover:bg-[#f7f5ef]">
          Agora não
        </button>
        <p className="mt-2 text-center text-[11px] leading-snug text-[#8a9088]">
          Ao abrir o arquivo, o Android pode pedir para permitir a instalação. É só confirmar.
        </p>
      </div>
    </div>
  );
}
